"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledFilterGroupLabel = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Refresh = _interopRequireDefault(require("../../icons-react/rebrand/Refresh"));
var _ChevronDown = _interopRequireDefault(require("../../icons-react/rebrand/ChevronDown"));
var _Collapsible = _interopRequireDefault(require("../Collapsible"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FilterGroup = function FilterGroup(_ref) {
  var label = _ref.label,
    _ref$showClearBtn = _ref.showClearBtn,
    showClearBtn = _ref$showClearBtn === void 0 ? false : _ref$showClearBtn,
    onClear = _ref.onClear,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    _ref$isCollapsible = _ref.isCollapsible,
    isCollapsible = _ref$isCollapsible === void 0 ? false : _ref$isCollapsible,
    _ref$isClearButtonInl = _ref.isClearButtonInline,
    isClearButtonInline = _ref$isClearButtonInl === void 0 ? false : _ref$isClearButtonInl;
  var _useState = (0, _react.useState)(!!isCollapsible),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isCollapsed = _useState2[0],
    setIsCollapsed = _useState2[1];
  var handleClickLabel = function handleClickLabel() {
    return isCollapsible ? setIsCollapsed(!isCollapsed) : null;
  };
  var handleClickClearButton = function handleClickClearButton(e) {
    e.stopPropagation();
    if (onClear) {
      onClear();
    }
  };
  var showInlineClearButton = showClearBtn && isClearButtonInline;
  var showBlockClearButton = showClearBtn && !isClearButtonInline;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledFilterGroupLabel, {
    $isMobile: isMobile,
    $isCollapsible: isCollapsible,
    onClick: handleClickLabel
  }, /*#__PURE__*/_react["default"].createElement("span", null, label), showInlineClearButton && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\xA0", /*#__PURE__*/_react["default"].createElement(StyledClearIcon, {
    $isMobile: isMobile,
    $isInline: true,
    onClick: handleClickClearButton
  })), isCollapsible && /*#__PURE__*/_react["default"].createElement(StyledChevronIcon, {
    $isOpen: !isCollapsed
  }), showBlockClearButton && /*#__PURE__*/_react["default"].createElement(StyledClearIcon, {
    $isMobile: isMobile,
    onClick: onClear
  })), /*#__PURE__*/_react["default"].createElement(_Collapsible["default"], {
    isCollapsed: isCollapsed
  }, children));
};
var StyledFilterGroupLabel = exports.StyledFilterGroupLabel = _styledComponents["default"].div.withConfig({
  displayName: "FilterGroup__StyledFilterGroupLabel",
  componentId: "sc-1vw368t-0"
})(["display:flex;justify-content:space-between;align-items:center;gap:8px;margin-bottom:8px;", " ", " font-size:", "px;line-height:", "px;font-style:normal;font-weight:500;color:var(--black);"], function (_ref2) {
  var $isCollapsible = _ref2.$isCollapsible;
  return $isCollapsible && (0, _styledComponents.css)(["cursor:pointer;"]);
}, function (_ref3) {
  var $isMobile = _ref3.$isMobile;
  return $isMobile && (0, _styledComponents.css)(["margin-left:10px;margin-right:10px;"]);
}, function (_ref4) {
  var $isMobile = _ref4.$isMobile;
  return $isMobile ? 18 : 16;
}, function (_ref5) {
  var $isMobile = _ref5.$isMobile;
  return $isMobile ? 22 : 20;
});
var StyledChevronIcon = (0, _styledComponents["default"])(_ChevronDown["default"]).withConfig({
  displayName: "FilterGroup__StyledChevronIcon",
  componentId: "sc-1vw368t-1"
})(["height:20px;flex-shrink:0;cursor:pointer;", ""], function (_ref6) {
  var $isOpen = _ref6.$isOpen;
  return $isOpen && (0, _styledComponents.css)(["transform:rotate(180deg);"]);
});
var StyledClearIcon = (0, _styledComponents["default"])(_Refresh["default"]).withConfig({
  displayName: "FilterGroup__StyledClearIcon",
  componentId: "sc-1vw368t-2"
})(["cursor:pointer;path{fill:var(--grey1);}height:", "px;margin-left:", "px;", ""], function (_ref7) {
  var $isMobile = _ref7.$isMobile;
  return $isMobile ? 22 : 20;
}, function (_ref8) {
  var $isInline = _ref8.$isInline;
  return $isInline ? 0 : 10;
}, function (_ref9) {
  var $isInline = _ref9.$isInline;
  return $isInline && (0, _styledComponents.css)(["vertical-align:text-top;"]);
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(FilterGroup);